import zIndex from '@mui/material/styles/zIndex';
import './App.css';
import AppRoutes from './Routes/routes';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <>
      <AppRoutes />
      {/* <ToastContainer
        position="top-right"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        sx={{
          zIndex: 1000
        }}
      /> */}
    </>
  );
}

export default App;
